import { Component, OnInit, Input, Output, EventEmitter }   from "@angular/core";
import { ActivatedRoute }                                   from "@angular/router";
import { Message, Pagination }                              from "../../../models";
import { USERHOMECONSTANTS }                                from "../userHome.constants";
import { CurrentUserService }                               from "../../../services/shared";
import { MessagesService }                                  from "./messages.service";
import { UserHomeService }                                  from "../userHome.service";

@Component({
    selector: "messages-component",
    template: require("./messages.component.html"),
    styles: [require("./messages.component.less").toString()],
    providers: [MessagesService]
})

export class MessagesComponent implements OnInit {
    @Input() messageList: Message[];
    @Output() refreshList: EventEmitter<any> = new EventEmitter();
    errorMessage: string;
    showReadMessages: boolean;
    hasViewPermission: boolean;
    userToProcess: string = "";
    messagesComponent = {
        sortColumnIndex: 1,
        sortOrder: USERHOMECONSTANTS.sorting.descOrderString,
        sortColumn: "DateSent",
        pagination: new Pagination(),
        messages: new Array<Message>()
    };

    constructor(private activatedRoute: ActivatedRoute,
        private messageService: MessagesService,
        private userHomeService: UserHomeService,
        private currentUserService: CurrentUserService) {
        this.messagesComponent.pagination = {
            totalItems: 0,
            currentPage: USERHOMECONSTANTS.pagination.currentPage,
            itemsPerPage: USERHOMECONSTANTS.pagination.itemsPerPage,
            maxSize: USERHOMECONSTANTS.pagination.maxSize
        };
    }

    public ngOnInit() {
        this.showReadMessages = false;
        // Apply security rules
        let token = this.currentUserService.token;
        if (token) {
            // Global admins can view messages ot other users
            if (this.activatedRoute.snapshot.queryParams[USERHOMECONSTANTS.params.userId]) {
                this.userToProcess = this.activatedRoute.snapshot.queryParams[USERHOMECONSTANTS.params.userId];
                this.hasViewPermission = this.currentUserService.IsGlobalAdmin();
            } else {
                this.userToProcess = this.currentUserService.token.userId;
                // Logged in user can view own messages
                this.hasViewPermission = true;
            }
        };

        this.SearchMessages();
    }

    public SortIconClass(columnIndex): string {
        if (columnIndex === this.messagesComponent.sortColumnIndex) {
            if (this.messagesComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                return USERHOMECONSTANTS.sorting.ascIconClass;
            } else {
                return USERHOMECONSTANTS.sorting.descIconClass;
            }
        } else {
            return "";
        }
    }

    public SortList(columnIndex: number) {
        if (columnIndex === this.messagesComponent.sortColumnIndex) {
            if (this.messagesComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                this.messagesComponent.sortOrder = USERHOMECONSTANTS.sorting.descOrderString;
            } else {
                this.messagesComponent.sortOrder = USERHOMECONSTANTS.sorting.ascOrderString;
            }
        } else {
            this.messagesComponent.sortOrder = USERHOMECONSTANTS.sorting.ascOrderString;
            switch (columnIndex) {
                case 1:
                    this.messagesComponent.sortColumn = "MessageStatusCode";
                    break;
                case 2:
                    this.messagesComponent.sortColumn = "DateSent";
                    break;
                case 3:
                    this.messagesComponent.sortColumn = "ApplicationName";
                    break;
                case 4:
                    this.messagesComponent.sortColumn = "MessageFrom";
                    break;
                case 5:
                    this.messagesComponent.sortColumn = "ToRoleCode";
                    break;
                case 6:
                    this.messagesComponent.sortColumn = "ToUserId";
                    break;
                case 7:
                    this.messagesComponent.sortColumn = "Subject";
                    break;
                default:
                    this.messagesComponent.sortColumn = "MessageStatusCode";
            }
        }
        this.messagesComponent.sortColumnIndex = columnIndex;
        this.SearchMessages();
    }

    public PageChanged(currentPageObject) {
        this.messagesComponent.pagination.currentPage = currentPageObject.page;
        this.SearchMessages();
    }
    public RefreshMessageList(showReadMessages) {
        this.showReadMessages = showReadMessages;
        this.SearchMessages();
    }

    public SearchMessages(): void {
        this.messageService
            .SearchMessages(this.messagesComponent.pagination, this.messagesComponent.sortOrder,
            this.messagesComponent.sortColumn, this.showReadMessages)
            .map(response => response.json())
            .subscribe(
            response => {
                this.refreshList.emit(<Message[]>response.result);
                this.messagesComponent.pagination.totalItems = response.count; // get from the response 
                this.userHomeService.confirmTotalItemUpdate(response.count); // get from the response
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/messages/messages.component.ts